var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041A\\u0430\\u0440\\u0442\\u0430",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.6 23.3",
    style: {
      enableBackground: "new 0 0 31.6 23.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;}\n\t.st2{fill:none;stroke-linejoin:round;}\n\t.st3{fill:none;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,0h27.6c1.1,0,2,0.9,2,2v19.3c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    stroke: "current",
    d: "M2,0.5h27.6c0.8,0,1.5,0.7,1.5,1.5v19.3c0,0.8-0.7,1.5-1.5,1.5H2c-0.8,0-1.5-0.7-1.5-1.5V2 C0.5,1.2,1.2,0.5,2,0.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    transform: "translate(3.008 3.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,0h3.8c1.7,0,3,1.3,3,3v1.5c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3C0,1.3,1.3,0,3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    stroke: "current",
    d: "M3,0.5h3.8c1.4,0,2.5,1.1,2.5,2.5v1.5C9.3,5.9,8.2,7,6.8,7H3C1.6,7,0.5,5.9,0.5,4.5V3C0.5,1.6,1.6,0.5,3,0.5z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    className: "st1",
    stroke: "current",
    d: "M3.9,0.8V7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    className: "st1",
    stroke: "current",
    d: "M0.4,4h3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    className: "st1",
    stroke: "current",
    d: "M5.8,6.8V4C5.8,4,5.6,3,6.6,3h2.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_345",
    transform: "translate(3.008 15.038)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 5.5,0.5 5.5,0.5  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_347",
    transform: "translate(3.008 17.294)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 1.8,0.5 1.8,0.5  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_348",
    transform: "translate(6.015 17.294)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 1.8,0.5 1.8,0.5  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_349",
    transform: "translate(9.023 17.294)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 1.8,0.5 1.8,0.5  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_350",
    transform: "translate(12.03 17.294)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 1.8,0.5 1.8,0.5  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_351",
    transform: "translate(15.038 17.294)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    stroke: "current",
    points: "0.5,0.5 1,0.5 1,0.5  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_346",
    transform: "translate(9.775 15.038)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    stroke: "current",
    points: "0.5,0.5 6.3,0.5 6.3,0.5  "
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_72",
    transform: "translate(18.045 12.792)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 3.8,
    cy: 3.8,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    stroke: "current",
    cx: 3.8,
    cy: 3.8,
    rx: 3.3,
    ry: 3.3
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73",
    transform: "translate(21.383 12.792)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 3.8,
    cy: 3.8,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    stroke: "current",
    cx: 3.8,
    cy: 3.8,
    rx: 3.3,
    ry: 3.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4db85b88f17a9b1ef96627777fcae635.svg";
export { ForwardRef as ReactComponent };